import { ShiftSummary } from '../interfaces/shift-summery';
import { roundDecimalHalfUp, PAYMENT_AMOUNT_DECIMAL_PLACES } from './decimal-round.util';

export interface ShiftSummaryRowDef {
  labelKey: string;
  saleProp: keyof ShiftSummary;
  returnProp?: keyof ShiftSummary;
  /** When set, sale column = saleProp minus this field. */
  saleTaxProp?: keyof ShiftSummary;
  /** When set, return column = returnProp minus this field. */
  returnTaxProp?: keyof ShiftSummary;
}

export const SHIFT_SUMMARY_ROWS: ShiftSummaryRowDef[] = [
  { labelKey: 'SHIFT_SUMMARY.CASH', saleProp: 'cashAmount', returnProp: 'returnCashAmount' },
  { labelKey: 'SHIFT_SUMMARY.BANK', saleProp: 'creditCardAmount', returnProp: 'returnCreditCardAmount' },
  { labelKey: 'SHIFT_SUMMARY.POST_PAY', saleProp: 'postPayAmount', returnProp: 'returnPostPayAmount' },
  {
    labelKey: 'SHIFT_SUMMARY.TOTAL_EXCLUDING_TAX',
    saleProp: 'totalAmount',
    returnProp: 'totalReturns',
    saleTaxProp: 'taxAmount',
    returnTaxProp: 'taxReturnAmount',
  },
  { labelKey: 'SHIFT_SUMMARY.TAX', saleProp: 'taxAmount', returnProp: 'taxReturnAmount' },
  { labelKey: 'SHIFT_SUMMARY.NET', saleProp: 'netAmount' },
];

function shiftSummaryNumeric(summary: ShiftSummary, prop: keyof ShiftSummary): number {
  const value = Number(summary[prop] ?? 0);
  return Number.isFinite(value) ? value : 0;
}

function roundShiftAmount(value: number): number {
  return roundDecimalHalfUp(value, PAYMENT_AMOUNT_DECIMAL_PLACES);
}

export function getShiftSummaryRowSaleValue(summary: ShiftSummary, row: ShiftSummaryRowDef): number {
  const base = shiftSummaryNumeric(summary, row.saleProp);
  if (!row.saleTaxProp) {
    return roundShiftAmount(base);
  }
  return roundShiftAmount(base - shiftSummaryNumeric(summary, row.saleTaxProp));
}

export function getShiftSummaryRowReturnValue(summary: ShiftSummary, row: ShiftSummaryRowDef): number | null {
  if (!row.returnProp) {
    return null;
  }
  const base = shiftSummaryNumeric(summary, row.returnProp);
  if (!row.returnTaxProp) {
    return roundShiftAmount(base);
  }
  return roundShiftAmount(base - shiftSummaryNumeric(summary, row.returnTaxProp));
}

export function getShiftSummaryRowNetValue(summary: ShiftSummary, row: ShiftSummaryRowDef): number {
  const sale = getShiftSummaryRowSaleValue(summary, row);
  const returnValue = getShiftSummaryRowReturnValue(summary, row);
  if (returnValue === null) {
    return sale;
  }
  return roundShiftAmount(sale - returnValue);
}
